module.exports = __webpack_public_path__ + "img/3-4-1.2c3ae6c3.png";